import { Injectable, Inject } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Circuit } from '@app/shared/models/circuit.model';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { timeout, retry, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CircuitService {
    private apiUrl = `${environment.apiHost}/circuit`;

    constructor(private http: HttpClient, @Inject(OKTA_AUTH) public oktaAuth: OktaAuth) {
    }

    async getCircuitData(storeNumber: string) {
        return this.http.get<Circuit>(`${this.apiUrl}/lumen-fiber?storeNumber=${storeNumber}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(2500),
                retry(3),
                catchError( error => of("Request for circuit data timed out!"))
            );
    }

    async getNetboxCircuit(storeNumber: string) {
        return this.http.get<Circuit>(`${this.apiUrl}/netbox-circuit?storeNumber=${storeNumber}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(2500),
                retry(3),
                catchError( error => of("Request for Netbox Circuit timed out!"))
            );
    }
}